// extracted by mini-css-extract-plugin
module.exports = {"img":"_7a3fb80146--img--jwANs","title":"_7a3fb80146--title--oQVS9","distance":"_7a3fb80146--distance--VO626"};